import { useEffect } from 'react';
import { RgbColor, rgbToHex } from '~/shared';
import { TextLabelStrokeRoboto } from '../TextLabelStroke';

interface IPlayerMessageProps {
	username: string;
	usernameColor: RgbColor;
	text: string;
	onRender?: () => void;
}

const PlayerMessage: React.FC<IPlayerMessageProps> = ({
	username,
	usernameColor,
	text,
	onRender,
}: IPlayerMessageProps) => {
	useEffect(() => {
		onRender?.();
	}, []);

	return (
		<TextLabelStrokeRoboto
			style={{
				fontSize: 14,
				justifyContent: 'start',
				wordWrap: 'break-word',
				fontWeight: 600,
			}}
		>
			<span
				style={{
					color: `#${rgbToHex(usernameColor)}`,
					whiteSpace: 'nowrap',
				}}
			>
				{username}:
			</span>
			&nbsp;{text}
		</TextLabelStrokeRoboto>
	);
};

export { PlayerMessage };
